/* Black Friday 2026 · cuenta atrás en dos fases.
   - Antes de data-start: "Empieza en" hasta el inicio.
   - Entre data-start y data-end: "Termina en" hasta el final.
   - Después de data-end: se oculta (nunca se queda a cero). */
if (!customElements.get('bf-countdown')) {
  customElements.define(
    'bf-countdown',
    class BfCountdown extends HTMLElement {
      connectedCallback() {
        this.start = Date.parse(this.dataset.start || '');
        this.end = Date.parse(this.dataset.end || '');
        this.label = this.querySelector('[data-bf-label]');
        this.nums = {
          d: this.querySelector('[data-bf-d]'),
          h: this.querySelector('[data-bf-h]'),
          m: this.querySelector('[data-bf-m]'),
          s: this.querySelector('[data-bf-s]'),
        };
        if (Number.isNaN(this.end)) return;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const now = Date.now();
        let target;
        if (!Number.isNaN(this.start) && now < this.start) {
          target = this.start;
          this.setLabel(this.dataset.labelBefore);
        } else if (now < this.end) {
          target = this.end;
          this.setLabel(this.dataset.labelDuring);
        } else {
          this.hidden = true;
          clearInterval(this.timer);
          return;
        }
        const diff = Math.max(0, target - now);
        const pad = (n) => String(n).padStart(2, '0');
        this.nums.d.textContent = pad(Math.floor(diff / 86400000));
        this.nums.h.textContent = pad(Math.floor((diff / 3600000) % 24));
        this.nums.m.textContent = pad(Math.floor((diff / 60000) % 60));
        this.nums.s.textContent = pad(Math.floor((diff / 1000) % 60));
        this.hidden = false;
      }

      setLabel(text) {
        if (this.label && text && this.label.textContent !== text) this.label.textContent = text;
      }
    }
  );
}
